// Ozlo Sticky Header Component
// Extracted from ozlo-main.js

if (!customElements.get('ozlo-sticky-header')) {
  customElements.define('ozlo-sticky-header', class OzloStickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.headerIsAlwaysSticky = false;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = null;
      this.searchModal = null;
      this.disclosures = null;
      this.isScrolling = null;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      const stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size';

      this.setHeaderHeight();

      // Update header height on mobile breakpoint change
      window.matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Don't change header if predictive search is open
      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        return;
      }

      // Scrolling down past header
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }
      }
      // Scrolling up past header
      else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        } else {
          requestAnimationFrame(this.reveal.bind(this));
        }
      }
      // At top of page
      else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }
    }

    reveal() {
      if (!this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky',
          'animate'
        );
        this.header.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (!this.headerIsAlwaysSticky) {
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  });
}
